import {Button, Group, Modal, Stack, Text} from '@mantine/core';
import React from 'react';

export interface AntibodyComponentMigrationConfirmRollbackModalProps {
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  isRollingBack?: boolean;
}

export function AntibodyComponentMigrationConfirmRollbackModal({
  onConfirm,
  onClose,
  isRollingBack = false,
}: AntibodyComponentMigrationConfirmRollbackModalProps): JSX.Element {
  return (
    <Modal
      title="Confirm rollback migration"
      opened={true}
      onClose={onClose}
      size="md"
      padding="lg"
      closeOnClickOutside={!isRollingBack}
      closeOnEscape={!isRollingBack}
      withCloseButton={!isRollingBack}
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <Stack spacing="lg">
        <Stack spacing="sm">
          <Text>
            The newly created destination fields and all data created by this migration will be deleted.
          </Text>
          <Text>
            The original fields and their data will not be affected. Data entered during the migration will be
            preserved on those fields, and can be safely re-migrated in the future.
          </Text>
        </Stack>
        <Group position="right">
          <Button variant="secondary" onClick={onClose} disabled={isRollingBack}>
            Cancel
          </Button>
          <Button variant="warn" onClick={onConfirm} loading={isRollingBack} data-autofocus={true}>
            Rollback migration
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
